module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tracking-chart"
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "position": "relative",
      "height": "40vh",
      "width": "100%"
    }
  }, [_c('canvas', {
    ref: "chart",
    staticClass: "chart"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a49a490","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Specific/TrackingChart.vue
// module id = 1895
// module chunks = 0